module.exports = __webpack_public_path__ + "img/anh-p6.96ac7dc6.png";